





























import Vue from 'vue';
import moment from 'moment';
import { Actions } from '@/store';
import {
  LatestKudosPhoto,
  Leaderboard,
  Opportunities,
  RecentActivities,
} from '@/components/kitchen-tv';

import Loader from '@/components/core/Loader.vue';
import Velocity from 'velocity-animate';

export default Vue.extend({
  name: 'KitchenTvView',
  components: {
    LatestKudosPhoto,
    Leaderboard,
    Loader,
    Opportunities,
    RecentActivities,
  },
  data() {
    return {
      loader: {
        isPending: false,
      },
      view: 0,
      carousel: [
        'Leaderboard',
        'RecentActivities',
        'LatestKudosPhoto',
        'Opportunities',
      ],
      slide: {
        show: false,
        slideDuration: 500,
        slidePause: 5000,
        delay: 10000,
        multiply: {
          length: 0,
          current: 0,
        },
      },
      progress: {
        percentageDone: 0,
        timeStarted: 0,
        timeEnded: 0,
      },
      roll: {
        on: false,
        speed: 0.02, // height in px / time in ms
        distance: 0,
        time: 0,
      },
      currentProperties: {},
    };
  },

  mounted() {
    this.initBoard();
    window.setInterval(this.computePercentage, 10);
  },
  updated() {
    const boardContainer = document.getElementById('kitchen-tv');
    this.roll.distance = boardContainer!.clientHeight - window.innerHeight;
    this.roll.time = Math.round(this.roll.distance / this.roll.speed);
  },
  computed: {
    percentageDone(): number {
      return this.progress.percentageDone;
    },
    boardTimeInterval(): number {
      return (this.roll.distance > 0) ? Math.max.apply(null, [this.roll.time, this.slide.delay]) : this.slide.delay;
    },
    progressTimeInterval(): number {
      const defaultTime = (this.boardTimeInterval + (2 * this.slide.slideDuration));
      return (this.roll.distance > 0) ? defaultTime + this.slide.slidePause : defaultTime;
    },
    currentComponent(): string {
      return this.carousel[this.view];
    },
  },
  methods: {
    setMultiplySlide(items: []): void {
        this.slide.multiply.length = items.length;
        this.currentProperties = { path: items[this.slide.multiply.current] };
    },
    resetProgressBar(): void {
      this.slide.show = false;
      this.progress.percentageDone = 0;
      this.progress.timeStarted = new Date().getTime();
      this.progress.timeEnded = this.progress.timeStarted + this.progressTimeInterval;
    },
    computePercentage(): void {
      const timePassed = new Date().getTime() - this.progress.timeStarted;
      this.progress.percentageDone = (timePassed / this.progressTimeInterval) * 100;
    },
    changeBoard(): void {
      this.resetProgressBar();

      if (this.slide.multiply.length > 0 && this.slide.multiply.current + 1 < this.slide.multiply.length) {
        this.slide.multiply.current = this.slide.multiply.current + 1;
        this.view = this.view;
      } else {
        this.slide.multiply.length = 0;
        this.slide.multiply.current = 0;
        this.view = (this.view + 1 === this.carousel.length) ? 0 : this.view + 1;
      }

      this.slide.show = true;
    },
    changeBoardWithReset(): void {
      const board = document.getElementById(this.carousel[this.view]);
      if (board) {
        Velocity(board, 'stop', true);
        board.remove();
      }
      this.changeBoard();
    },
    initBoard(): void {
      this.resetProgressBar();
      this.slide.show = true;
    },
    beforeEnter(el: HTMLElement): void {
      el.style.opacity = '0';
    },
    enter(el: HTMLElement, done: CallableFunction): void {
      Velocity(el, { opacity: 1 });
      Velocity(el, { translateX: [0, '100%'] }, {
        duration: this.slide.slideDuration,
        complete: () => {
          done();
          this.slide.show = false;
        },
      });
    },
    leave(el: HTMLElement, done: CallableFunction): void {
      if (this.roll.distance > 0) {
        Velocity(el, { translateY: -this.roll.distance }, { duration: this.boardTimeInterval, easing: 'linear' });
        Velocity(el, { opacity: 1 }, { duration: this.slide.slidePause });
      } else {
        Velocity(el, { opacity: 1 }, { duration: this.boardTimeInterval });
      }
      Velocity(el, { translateX: '-100%' }, {
        duration: this.slide.slideDuration,
        complete: () => {
          this.changeBoard();
          done();
        },
      });
    },
  },
});
